// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"6a5760d5","92":"cc635385","99":"c527d74f","215":"e50706ff","337":"c73350b5","443":"d034e009","453":"1118e87d","479":"bfcc59e3","531":"51d0cca4","952":"bda0c13b"}[chunkId] + ".chunk.js";
};